/* eslint-disable */
import StaticPage from '@fr/pages/mobile/travelata/default-application/static/staticPage';

import './scss/payment.scss';

$(() => {
	new StaticPage({ el: $('#payment-page'), scrollTopPosition: 50 });
});
